module.exports = __webpack_public_path__ + "img/livepeer.51345d32.svg";